// extracted by mini-css-extract-plugin
export var overlay = "Modal-module--overlay--WSsyO";
export var inner = "Modal-module--inner--26WOx";